import "../expense-claim/expenseClaim.css";
import Directory from "./directory";
import EmpDetails from "./EmpDetails";
import Salaries from "./Salaries";
import SalaryRevision from "./SalaryRevision";
import SalaryRevisionAction from "./SalaryRevisionAction";
import Loans from "./Loans/Loans";
import LoanRequest from "./Loans/LoanRequest";
import LoanDeduction from "./Loans/LoanDeduction";
import Bonus from "./Bonus";
import CompanyPaidAllowance from "./CompanyPaidAllownace";
import Gratuity from "./Gratuity";
import GratuityMaster from "./GratuityMaster";
import ExitProcess from "./ExitProcess";
import ExitEmployee from "./ExitEmployee";
import SalaryBreakdown from "./SalaryBreakdown";

const PayrollConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: "/payroll",
      element: <Directory />,
    },
    {
      path: "/salary/revision/action",
      element: <SalaryRevisionAction />,
    },
    {
      path: "/loans/request",
      element: <LoanRequest revision={false} />,
    },
    {
      path: "/loans/revision",
      element: <LoanRequest revision={true} />,
    },
    {
      path: "/loan/deduction",
      element: <LoanDeduction />,
    },
    {
      path: "/loans",
      element: <Loans />,
    },
    {
      path: "/bonus",
      element: <Bonus />,
    },
    {
      path: "/gratuity",
      element: <Gratuity />,
    },
    {
      path: "/gratuity/master",
      element: <GratuityMaster />,
    },
    {
      path: "/exit-process",
      element: <ExitProcess />,
    },
    {
      path: "/exit-process/emp-details",
      element: <ExitEmployee />,
    },
    {
      path: "/cpa",
      element: <CompanyPaidAllowance />,
    },
    {
      path: "/salary/revision",
      element: <SalaryRevision />,
    },
    {
      path: "/generate",
      element: <Salaries generatePayroll={true} />,
    },
    {
      path: "/salaries",
      element: <Salaries generatePayroll={false} />,
    },
    {
      path: "/payroll/employee/profile",
      element: <EmpDetails />,
    },
    {
      path: "/salaryBreakdown",
      element: <SalaryBreakdown />,
    },
  ],
};

export default PayrollConfig;
